import React from "react";
import { useLocation } from "react-router-dom";
import WikiSearchResult from "./WikiSearchResult";

const withWikiWrapper = (Component) => (props) => {
  const { search } = useLocation();
  if (search && search.length) {
    const searchParams = new URLSearchParams(search);
    return <WikiSearchResult keyword={searchParams.get("keyword")} />;
  }

  return <Component {...props} />;
};

export default withWikiWrapper;
